// URL da foto do sócio a partir do registro (campo `physicalCardPicture`,
// um JSON `{ path, name }`). Devolve `undefined` quando não há foto válida
// — nesse caso o <Avatar> cai nas iniciais. Cadastros antigos com o campo
// gravado errado (texto puro, antes da correção do upload) também caem no
// undefined, sem quebrar. A base vem do REACT_APP_UPLOAD_PATH (ex.:
// https://uploads.portalclubedeengenharia.org.br).
export const socioPhotoUrl = (record: any): string | undefined => {
  const path = record?.physicalCardPicture?.path;
  if (!path || typeof path !== "string") return undefined;
  return `${process.env.REACT_APP_UPLOAD_PATH}/${path}`;
};
